import { createSlice } from "@reduxjs/toolkit";
import { fetchVideoAccess, fetchPeerInfo } from "./operation.js";

const initialState = {
  roomId: "",
  peerId: "",
  peerName: "",
  loading: false,
  error: null,
};

const videoSlice = createSlice({
  name: "video",
  initialState,
  reducers: {
    clearVideoState: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchVideoAccess.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchVideoAccess.fulfilled, (state, action) => {
        state.loading = false;
        state.roomId = action.payload.roomId;
        state.peerId = action.payload.peerId;
      })
      .addCase(fetchVideoAccess.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload.message;
      })
      .addCase(fetchPeerInfo.fulfilled, (state, action) => {
        state.peerName = action.payload.name;
      })
      .addCase(fetchPeerInfo.rejected, (state, action) => {
        state.error = action.payload.message;
      });
  },
});

export const { clearVideoState } = videoSlice.actions;
export const videoReducer = videoSlice.reducer;
